/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'virtualService';
const componentName = 'virtual-service-preview';
const prefix = `${moduleName}.${componentName}`;

export const wafEvaluationHeaderLabel = `${prefix}.wafEvaluationHeaderLabel`;
export const wafEvaluationContentLabel = `${prefix}.wafEvaluationContentLabel`;
export const tryWafButtonLabel = `${prefix}.tryWafButtonLabel`;
export const dismissButtonLabel = `${prefix}.dismissButtonLabel`;
export const wafPolicyLabel = `${prefix}.wafPolicyLabel`;
export const evaluationModeStatusText = `${prefix}.evaluationModeStatusText`;
export const wafSecurityPreviewImageAlt = `${prefix}.wafSecurityPreviewImageAlt`;

export const ENGLISH = {
    [wafEvaluationHeaderLabel]: 'WAF Evaluation',
    [wafEvaluationContentLabel]: 'WAF policy in Evaluation mode will sample your traffic by using otherwise unused CPU resources and give you insights how a WAF could help you.',
    [tryWafButtonLabel]: 'Try out WAF',
    [dismissButtonLabel]: 'Dismiss',
    [wafPolicyLabel]: 'WAF Policy',
    [evaluationModeStatusText]: 'Evaluation Mode',
    [wafSecurityPreviewImageAlt]: 'WAF Security Preview',
};
